import * as authenServiceURL from './authenServiceURL'
import useCallApi from '../../utilities/axios'
import useLoading from '../../control/loading/useLoading'

const usePDPA = () => {
    const callApi = useCallApi()
    const loadingHook = useLoading()

    const accept = async (userId: string) => {
        const { data } = await callApi.axiosPost<{ message: string }>({
            url: authenServiceURL.pdpa,
            params: { userID: userId },
        })
        return data
    }

    const getByUser = async (userId: string) => {
        const { data } = await callApi.axiosGet<any>({
            url: `${authenServiceURL.pdpa}/${userId}`,
        })
        return data
    }

    const get = async () => {
        try {
            loadingHook.loadingOpen()
            const { data } = await callApi.axiosGet<any>({
                url: authenServiceURL.pdpa,
            })
            return data
        } catch (err) {
        } finally {
            loadingHook.loadingClose()
        }
    }

    return { accept, getByUser, get }
}

export default usePDPA
